import React from 'react';
import { Provider } from 'react-redux';
import {
  Switch,
  BrowserRouter as Router,
  Route,
  Redirect,
} from 'react-router-dom';
import ReactGA from 'react-ga';
import Home from './containers/home';
import Portfolio from './containers/portfolio';
import About from './containers/about';
import Press from './containers/press';
import SayHello from './containers/sayHello';
import Project from './containers/project';
import Navbar from './containers/navBar';
import { NotFound } from './components/NotFound';
import Footer from './containers/footer';
import withTracker from './withTracker';

const Root = ({ store }) => {
  ReactGA.initialize('UA-124431945-1');
  return (
    <Provider store={store}>
      <Router>
        <div>
          <Navbar />
          <Switch>
            <Route path="/" exact component={withTracker(Home)} />
            <Route path="/portfolio" exact component={withTracker(Portfolio)} />
            <Route
              path="/portfolio/:project"
              component={withTracker(Project)}
            />
            <Route path="/about" component={withTracker(About)} />
            <Route path="/press" component={withTracker(Press)} />
            <Route path="/sayhello" component={withTracker(SayHello)} />
            <Route path="/index.html" render={() => <Redirect to="/" />} />
            <Route component={withTracker(NotFound)} />
          </Switch>
          <Footer />
        </div>
      </Router>
    </Provider>
  );
};

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js